import { FaFilm } from 'react-icons/fa';
import React, { useState } from 'react';
import THEME from '../utils/theme';
import { getYouTubeId } from '../utils/helpers';
import SectionTag from '../components/SectionTag';
import Loader from '../components/Loader';
import useFetch from '../hooks/useFetch';
import useInView from '../hooks/useInView';

function VideoCard({ v }) {
  const [playing, setPlaying] = useState(false);
  const ytId = getYouTubeId(v.youtubeUrl);
  const thumb = ytId ? `https://img.youtube.com/vi/${ytId}/hqdefault.jpg` : null;

  return (
    <div className="sk-card-hover" style={{
      background: 'white', borderRadius: 12, overflow: 'hidden',
      border: '1px solid #EDE7DE', cursor: 'pointer',
    }} onClick={() => setPlaying(p => !p)}>
      <div style={{ position: 'relative', paddingTop: '56.25%', background: THEME.navy }}>
        {playing && ytId ? (
          <iframe
            src={`https://www.youtube.com/embed/${ytId}?autoplay=1`}
            style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 'none' }}
            allow="autoplay; encrypted-media" allowFullScreen title={v.title}
          />
        ) : (
          <>
            {thumb && <img src={thumb} alt={v.title} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />}
            <div style={{
              position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.35)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <div style={{
                width: 56, height: 56, borderRadius: '50%', background: THEME.red,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: `0 8px 24px ${THEME.red}60`,
              }}>
                <span style={{ color: 'white', fontSize: 20, marginLeft: 4 }}>▶</span>
              </div>
            </div>
          </>
        )}
      </div>
      <div style={{ padding: '16px 18px' }}>
        <h4 style={{ fontFamily: "'Syne', sans-serif", fontSize: 15, fontWeight: 600, color: THEME.navy, lineHeight: 1.4 }}>
          {v.title}
        </h4>
        <span style={{
          display: 'inline-block', marginTop: 8,
          background: THEME.sand, color: '#888', fontSize: 10, fontWeight: 700,
          padding: '3px 10px', borderRadius: 2, fontFamily: "'Syne', sans-serif",
          textTransform: 'uppercase', letterSpacing: '0.06em',
        }}>{v.category}</span>
      </div>
    </div>
  );
}

export default function Videos() {
  const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const { data: videos, loading } = useFetch(`${API_BASE}/videos`);
  const [ref, visible] = useInView();
  const active = videos.filter(v => v.isActive);

  return (
    <section id="videos" style={{ padding: '100px clamp(20px,4vw,40px)', background: THEME.ivory }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div ref={ref} className={`sk-fade-up ${visible ? 'sk-visible' : ''}`}>
          <SectionTag>Video Gallery</SectionTag>
          <h2 style={{ fontFamily: "'Syne', sans-serif", fontWeight: 800, fontSize: 'clamp(2rem,4vw,3.2rem)', lineHeight: 1.1, color: THEME.navy }}>
            Watch Our Training in Action
          </h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '16px 0 48px' }}>
            <span style={{ fontFamily: "'Noto Serif',serif", fontSize: 13, color: `${THEME.red}80`, letterSpacing: '0.1em' }}>
              動画を見る
            </span>
            <div style={{ flex: 1, height: 1, background: `linear-gradient(90deg, ${THEME.red}40, transparent)` }} />
          </div>
        </div>

        {loading ? <Loader /> : active.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 80, background: 'white', borderRadius: 12, border: '1px solid #EDE7DE' }}>
            <FaFilm size={48} color="#CCC" style={{ display: 'block', margin: '0 auto 12px' }} />
            <p style={{ color: '#999' }}>Videos coming soon</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 24 }}>
            {active.map((v, i) => (
              <div key={v._id} className={`sk-fade-up ${visible ? 'sk-visible' : ''}`} style={{ transitionDelay: `${i * 0.07}s` }}>
                <VideoCard v={v} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
